export default __webpack_public_path__ + "static/carleaseOverview2-12644b3cdbcb83b4ded98a0920311b15.png";